/**
 * ImageCarousel — simple solid image preview dengan prev/next.
 * Tidak ada smooth animation, tidak ada zoom on hover.
 */

import { useState } from "react";

interface Props {
  images: string[];
  alt: string;
}

export function ImageCarousel({ images, alt }: Props) {
  const [idx, setIdx] = useState(0);

  if (images.length === 0) {
    return (
      <div className="aspect-square bg-accent/5 border border-border rounded-md
                      flex items-center justify-center">
        <span className="font-sans text-sm text-ink-dim">Belum ada gambar</span>
      </div>
    );
  }

  const current = images[idx];

  return (
    <div>
      <div className="aspect-square bg-panel border border-border flex items-center justify-center overflow-hidden">
        <img
          src={current}
          alt={alt}
          className="w-full h-full object-cover"
          loading="lazy"
        />
      </div>
      {images.length > 1 && (
        <div className="mt-2 flex items-center justify-between">
          <button
            type="button"
            disabled={idx === 0}
            onClick={() => setIdx((i) => Math.max(0, i - 1))}
            className="font-mono text-2xs tracking-widest uppercase border border-border-strong px-2 py-1 disabled:opacity-30 hover:border-terminal hover:text-terminal"
          >
            [ ← prev ]
          </button>
          <span className="font-mono text-2xs text-ink-muted">
            {String(idx + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
          </span>
          <button
            type="button"
            disabled={idx === images.length - 1}
            onClick={() => setIdx((i) => Math.min(images.length - 1, i + 1))}
            className="font-mono text-2xs tracking-widest uppercase border border-border-strong px-2 py-1 disabled:opacity-30 hover:border-terminal hover:text-terminal"
          >
            [ next → ]
          </button>
        </div>
      )}
    </div>
  );
}